export const processPageData = {
  hero: {
    badge: "Our Development Process",
    headline: "A Proven Process for Reliable Digital Products",
    subtext:
      "From discovery to long-term support, our structured process keeps every project clear, on-time and built to scale.",
    primaryCTA: "Start Your Project",
    secondaryCTA: "Talk to a Laravel Expert",
  },
  intro: {
    title: "How We Deliver",
    text: "We follow a disciplined, transparent process that balances speed with quality. Each phase builds on the last, so you always know what is happening, what comes next and how your product is taking shape.",
  },
  steps: [
    { number: "01", title: "Discovery", desc: "We understand your business, goals, users and requirements before writing any code.", icon: "ri-search-line" },
    { number: "02", title: "Planning", desc: "We define architecture, scope, technology and a clear roadmap and timeline.", icon: "ri-map-2-line" },
    { number: "03", title: "UI/UX", desc: "We design intuitive, modern interfaces focused on usability and conversion.", icon: "ri-palette-line" },
    { number: "04", title: "Architecture", desc: "We design a scalable, maintainable technical architecture around your needs.", icon: "ri-stack-line" },
    { number: "05", title: "Development", desc: "We build secure, clean software in agile sprints with regular deliverables.", icon: "ri-code-s-slash-line" },
    { number: "06", title: "Testing", desc: "We validate functionality, security and performance with thorough testing.", icon: "ri-check-double-line" },
    { number: "07", title: "Deployment", desc: "We launch your application on reliable infrastructure with CI/CD.", icon: "ri-rocket-line" },
    { number: "08", title: "Support", desc: "We provide maintenance, monitoring and continuous improvements.", icon: "ri-heart-3-line" },
  ],
  principles: [
    { title: "Transparent Communication", desc: "Regular updates and clear reporting at every phase.", icon: "ri-chat-3-line" },
    { title: "Quality First", desc: "Clean code, testing and best practices are non-negotiable.", icon: "ri-shield-check-line" },
    { title: "Scalable by Design", desc: "Architecture built to grow with your business.", icon: "ri-expand-diagonal-line" },
    { title: "On Time, On Budget", desc: "Clear scope and milestones keep delivery predictable.", icon: "ri-time-line" },
  ],
  cta: {
    heading: "Ready to Start Your Project?",
    text: "Let's put our process to work on your next digital product.",
    primaryCTA: "Start Your Project",
    secondaryCTA: "Talk to a Laravel Expert",
  },
};